module.exports = __webpack_public_path__ + "media/images/city_img/h_2-6d0d132e2b93c231ba36ae77eb5eb998.jpg";